/* eslint-disable */
import React, { useEffect, useState, useRef } from "react";
import { default as MobilDatePicker } from "react-mobile-datepicker";
// import { DatePicker } from "react-rainbow-components";
import DatePicker from "react-datepicker";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import moment from "moment";
import { useSelector } from "react-redux";
import Collapse from "@material-ui/core/Collapse";
import { DownOutlined } from "@ant-design/icons";
// import datepicker_arrow from "assets/images/datepicker_arrow.png";

const monthMap = {
  0: "Jan",
  1: "Feb",
  2: "Mar",
  3: "Apr",
  4: "May",
  5: "Jun",
  6: "Jul",
  7: "Aug",
  8: "Sep",
  9: "Oct",
  10: "Nov",
  11: "Dec",
};

//@ts-ignore
const DatePickerFormItem = React.memo(({ component, item, form }) => {
  const pickerRef = useRef();
  const calendarRef = useRef();
  const [picker, setPicker] = useState({
    date: new Date(),
    isOpen: false,
  });

  const [selectedDate, setSelectedDate] = useState(null);
  const formValues = useSelector((state) => state.formValues);
  const selectedLanguage = useSelector((state) => state.selectedLanguage);

  let useFormFieldValue = null;
  if (component === "customer_data") {
    const { [item.name]: value = null } = form.getFieldValue(component) || {};
    useFormFieldValue = value;
  } else {
    const { [item.name]: value = null } = form.getFieldsValue() || {};
    useFormFieldValue = value;
  }

  useEffect(() => {
    if (useFormFieldValue) {
      const date = moment(useFormFieldValue, "DD-MM-YYYY").toDate();
      setPicker({
        ...picker,
        date,
      });
      setSelectedDate(date);
    }
  }, [useFormFieldValue]);

  useEffect(() => {
    let formFieldValue = null;
    if (component === "customer_data") {
      const { [item.name]: value = null } = formValues[component] || {};
      formFieldValue = value;
    } else {
      const { [item.name]: value = null } = formValues || {};
      formFieldValue = value;
    }
    if (formFieldValue) {
      const date = moment(formFieldValue, "DD-MM-YYYY").toDate();
      setPicker({
        ...picker,
        date,
      });
      setSelectedDate(date);
    }
  }, []);

  useEffect(() => {
    const pickerDocument = document.querySelector(
      ".react-calendar__navigation"
    );
    if (
      window.innerWidth > 992 &&
      picker.isOpen &&
      pickerDocument.childElementCount == 5
    ) {
      const label = document.createElement("div");
      label.className = "picker-label";
      const span = document.createElement("span");
      label.appendChild(span);
      pickerDocument.insertBefore(label, pickerDocument.children[2]);
      span.innerHTML = monthMap[picker.date.getMonth()];

      const div = document.createElement("div");
      div.className = "date-picker-year";
      const select = document.createElement("select");
      select.onchange = function () {
        const selectedValue = document.querySelector(
          ".react-calendar__navigation select"
        ).value;
        const newDate = moment(picker.date).set(
          "year",
          parseInt(selectedValue)
        );
        setPicker({ ...picker, date: new Date(newDate.toString()) });
      };
      for (let i = 1930; i <= moment().year(); i++) {
        const option = document.createElement("option");
        option.setAttribute("value", `${i}`);
        if (i == moment(picker.date).year())
          option.setAttribute("selected", "selected");
        option.innerHTML = `${i}`;
        select.append(option);
      }
      div.append(select);
      div.appendChild(select);
      pickerDocument.appendChild(div);
    }
  }, [picker.isOpen]);

  window.addEventListener("click", (e) => {
    if (
      window.innerWidth > 992 &&
      picker.isOpen &&
      !pickerRef.current?.contains(e.target) &&
      !calendarRef.current?.contains(e.target)
    ) {
      setPicker({ ...picker, isOpen: false });
    }
  });

  const dateConfig = {
    date: {
      format: "D",
      caption: "Day",
      step: 1,
    },
    month: {
      format: (value) => monthMap[value.getMonth()],
      caption: "Mon",
      step: 1,
    },
    year: {
      format: "YYYY",
      caption: "Year",
      step: 1,
    },
  };

  const handleSelect = (data) => {
    console.log(data);
  };

  const onChange = (date) => {
    // if (window.innerWidth > 992) {
    //   // setPicker({ date, isOpen: false });
    //   const selectedValue = document.querySelector(
    //     ".react-calendar__navigation select"
    //   );
    //   const dateYear = moment(date).year();
    //   // if (parseInt(selectedValue.value) != dateYear) {
    //   //   selectedValue.value = dateYear;
    //   // }
    //   handleUpdate(date);
    // } else {
    //   setPicker({
    //     ...picker,
    //     date: date,
    //   });
    // }
    setPicker({
      ...picker,
      date: date,
    });
    if (window.innerWidth > 992) handleUpdate(date);
  };

  const handleUpdate = (propsDate) => {
    if (
      !(propsDate instanceof Date) ||
      moment(propsDate).format("DD-MM-YYYY") ==
        form.getFieldValue("customer_data")?.Date_of_birth
    ) {
      setPicker({
        ...picker,
        isOpen: false,
      });
    }
    let formattedDate;
    if (propsDate) {
      formattedDate = moment(propsDate).format("DD-MM-YYYY");
    } else {
      formattedDate = moment(picker.date).format("DD-MM-YYYY");
    }
    if (component === "customer_data") {
      form.setFieldsValue({
        [component]: {
          [item.name]: formattedDate,
        },
      });
    } else {
      form.setFieldsValue({
        [item.name]: formattedDate,
      });
    }
    setSelectedDate(picker.date);
  };

  const togglePicker = () => {
    setPicker({
      ...picker,
      isOpen: !picker.isOpen,
    });
  };

  const onClear = () => {
    form.setFieldsValue({
      [component]: {
        [item.name]: undefined,
      },
    });
    setPicker({
      ...picker,
      isOpen: !picker.isOpen,
    });
    setSelectedDate(null);
  };

  useEffect(() => {
    const pickerLabel = document.querySelector(".picker-label");
    if (pickerLabel) pickerLabel.innerHTML = monthMap[picker.date.getMonth()];
  }, [picker.date]);
  // document
  //   .querySelector("button.react-calendar__navigation__label")
  //   ?.disabled = true;

  return (
    <div
      className="datepicker-holder"
      style={{ position: "relative" }}
      ref={pickerRef}
    >
      <div className="datepicker-header pointer" onClick={togglePicker}>
        <span
          className={
            selectedDate ? "custom-input-text" : "custom-input-placeholder"
          }
        >
          {selectedDate
            ? moment(selectedDate).format("DD-MM-YYYY")
            : item.placeholder[selectedLanguage]}
        </span>
        <DownOutlined style={{ fontSize: 12, color: "rgba(0, 0, 0, 0.25)" }} />
      </div>
      {window.innerWidth > 992 ? (
        <>
          {picker.isOpen && (
            <div id="picker-block" ref={calendarRef}>
              <Calendar
                onChange={onChange}
                value={new Date(picker.date)}
                showNavigation={true}
                prev2Label=""
                next2Label=""
                onClickDay={onChange}
                onActiveStartDateChange={(date) =>
                  onChange(date.activeStartDate)
                }
                activeStartDate={new Date(picker.date)}
                navigationAriaLabel="cdmcdcd"
              />
            </div>
          )}
        </>
      ) : (
        <Collapse in={picker.isOpen}>
          <div className="datepicker-body">
            <MobilDatePicker
              value={picker.date}
              isPopup={false}
              theme="android"
              showFooter={false}
              showHeader={false}
              isOpen={true}
              dateConfig={dateConfig}
              onSelect={handleSelect}
              onChange={onChange}
              min={new Date(1930, 0, 1)}
              max={new Date(moment().format("YYYY,MM,DD"))}
            />
          </div>
          <div className="datepicker-bottom">
            <div className="datepicker-bottom-item-holder">
              <span
                className="pointer"
                style={{ color: "#555555" }}
                onClick={onClear}
              >
                Clear
              </span>
            </div>
            <div className="datepicker-bottom-item-holder">
              <span
                className="pointer"
                style={{ color: "#C7315A" }}
                onClick={handleUpdate}
              >
                OK
              </span>
            </div>
          </div>
        </Collapse>
      )}
    </div>
  );
});

export default DatePickerFormItem;
